module.exports = __webpack_public_path__ + "static/media/folder.6b96a36d.svg";